import { BELIMO } from '../constants';
import { LocaleValuesFragment } from '../generated/operations';

export function getCompany(field: LocaleValuesFragment) {
  return field === null ? BELIMO : field.localized.join(', ');
}
